import { QUERY_KEYS } from "@/libraries/constant";
import type { UpdateGroupSchema } from "@/schemas";
import type { ResError, UpdateGroupResponse } from "@/types";
import { useMutation } from "@tanstack/react-query";

function useUpdateGroup() {
	return useMutation<UpdateGroupResponse, ResError, UpdateGroupSchema>({
		mutationKey: [QUERY_KEYS.MUTATE_GROUP_UPDATE],
	});
}

export default useUpdateGroup;
